<template>
  <b-card
    class="compCompactCard component-inside-1--hover full-bordered mt-2"
    :class="{'active':isActive}"
    @click="$emit('cardSelected')"
  >
    <div class="d-flex justify-content-center align-agnoitems-center">
      <span
        qa="complementaries-compact-cards-label"
        class="label-dark"
      >{{ complementary }}</span>
    </div>
  </b-card>
</template>

<script>
export default {
    name: 'ComplementaryCompactCard',
    props: {
        complementary: Number,
        isActive: Boolean
    }
}
</script>

<style lang="scss">
.col-md-auto {
  flex: 0 0 70px;
}
</style>

<style lang="scss" scoped>
.compCompactCard {
  height: 40px;
  width: 55px;
  cursor: pointer;
}

.compCompactCard .card-body {
  display: flex;
  align-items: center;
  justify-content: center;
}

.compCompactCard span {
  color: vt-color(dark-text);
  font-size: font-size(big);
}

.compCompactCard.active {
  background: vt-color(primary) !important;
}

.compCompactCard.active span {
  color: vt-color(white-light) !important;
}
</style>
